<template>
  <!-- 森林百科古树 -->
  <div class="gushuDetailPage">
    <van-loading size="24px" vertical v-if="loadingPicker"
      >加载中...</van-loading
    >
    <div v-if="!loadingPicker">
      <div
        :class="['header', 'ggPd', isRepaired == true ? '' : 'headerMainFalse']"
      >
        <dl class="treeMsg">
          <dt>
            <img :src="oldTreeGrade" />
            <a href="javascript:void(0)" @click="Share">分享好友></a>
          </dt>
          <dd class="treeName">{{ entryName }}</dd>
          <dd class="treeFamily">
            {{ family ? family : "" }}
            <span class="treeGenus">{{ genus ? genus : "" }}</span>
          </dd>
          <dd class="scan fl">
            <span>{{ scanNum }}</span
            >人扫过
          </dd>
        </dl>
        <!-- 未修复图标 -->
        <span class="headerFalse" v-if="showHeaderFalse"></span>
      </div>
      <div class="treeDetail">
        <div class="record ggList">
          <div class="ggPd">
            <div class="ggTit">
              <a
                href="javascript:void(0)"
                :class="[isRepaired == true ? ' ' : 'bottomChangeColor']"
                >古树档案</a
              >
              <p @click="getMap">
                <span
                  :class="[
                    isRepaired == true ? 'recordIcon' : 'recordIconFalse',
                    'heart',
                  ]"
                ></span>
                <i class="bubble">返回地图</i>
              </p>
            </div>
            <div
              :class="[
                isRepaired == true
                  ? 'recordMain'
                  : 'recordMain recordMainFalse',
              ]"
            >
              <p v-if="this.treeCode != null">
                <span>古树编号</span>
                {{ treeCode }}
              </p>
              <p v-if="this.entryName != null">
                <span>树种</span>
                {{ entryName }}
              </p>
              <p v-if="latinName" style="font-style: oblique">
                <span style="font-style: normal">拉丁文</span>
                {{ latinName }}
              </p>
              <p class="address">
                <span>所在地</span>
                <em class="amapJump" @click="showGetAmap = true">{{
                  regionCodeName
                }}</em>
              </p>
              <p v-if="placeName" class="clearfix">
                <span>小地名</span>
                {{ placeName }}
              </p>
              <p v-if="treeAge">
                <span>树龄</span>
                {{ treeAge }}年
              </p>
              <p v-if="rodDiameter != null">
                <span>胸围</span>
                {{ rodDiameter }}cm
              </p>
              <p v-if="treeHeight != null">
                <span>树高</span>
                {{ treeHeight }}m
              </p>
              <p v-if="crown">
                <span>平均冠幅</span>
                {{ crown }}m
              </p>
              <p v-if="elevation">
                <span>海拔</span>
                {{ elevation }}m
              </p>
              <p v-if="exposure">
                <span>坡向</span>
                {{ exposure }}
              </p>
              <p v-if="slope">
                <span>坡度</span>
                {{ slope }}度
              </p>
              <p v-if="position">
                <span>坡位</span>
                {{ position }}
              </p>
              <p v-if="growthPlace">
                <span>生长场所</span>
                {{ growthPlace }}
              </p>
              <p v-if="ownership">
                <span>权属</span>
                {{ ownership }}
              </p>
              <p v-if="soilName">
                <span>土壤名称</span>
                {{ soilName }}
              </p>
              <p v-if="growthPotential">
                <span>生长势</span>
                {{ growthPotential }}
              </p>
              <p v-if="growingEnvironment">
                <span>生长环境</span>
                {{ growingEnvironment }}
              </p>
              <p v-if="extantState">
                <span>现存状态</span>
                {{ extantState }}
              </p>
              <p v-if="protection">
                <span>地上保护现状</span>
                {{ protection }}
              </p>
              <p v-if="rejuvenation">
                <span>养护复壮现状</span>
                {{ rejuvenation }}
              </p>
              <p v-if="management">
                <span>管理单位</span>
                {{ management }}
              </p>
            </div>
          </div>
        </div>
        <p class="fgx"></p>
        <div class="history ggList" v-if="historicCulture != null">
          <div class="ggPd">
            <p class="ggTit">
              <a
                href="javascript:void(0)"
                :class="[isRepaired == true ? '' : 'bottomChangeColor']"
                >历史文化</a
              >
            </p>
            <p class="historyMain" v-html="historicCulture"></p>
          </div>
        </div>
        <p class="fgx"></p>
        <!-- 古树监控 -->
        <div class="treeMonitoring ggList" v-if="monitors && monitors[0]">
          <div class="ggPd">
            <!-- <p class="ggTit"> -->
            <!-- <a
                href="javascript:void(0)"
                :class="[isRepaired ? '' : 'bottomChangeColor']"
                >古树监测</a
              > -->
            <!-- </p> -->
            <!-- 古树监测数据 -->
            <monitoring-swipe :appType="treeType"></monitoring-swipe>
          </div>
        </div>
        <p class="fgx" v-if="monitors && monitors[0]"></p>
        <!-- 古树之家 -->
        <div class="treeHome ggList" v-if="imgUrls && imgUrls[0]">
          <div class="ggPd">
            <p class="ggTit">
              <a
                href="javascript:void(0)"
                :class="[isRepaired ? '' : 'bottomChangeColor']"
                >古树图片</a
              >
            </p>
          </div>
          <van-swipe
            @change="onChange"
            :loop="true"
            class="swiperTreeHome"
            v-if="this.imgUrls[0]"
          >
            <van-swipe-item
              v-for="(item, index) in imgUrls"
              :key="index"
              class="swiperTreeHomeItem"
            >
              <div class="TreeHomeImg" @click="magnifyImg(index)">
                <img
                  v-if="item"
                  @error="imgError(item, 1)"
                  :src="
                    item
                      ? item
                      : '' +
                        '?x-oss-process=image/resize,h_178)no-repeat center cover'
                  "
                />
              </div>
            </van-swipe-item>
            <div
              class="custom-indicator"
              slot="indicator"
              v-if="this.imgUrls != ''"
            >
              {{ TreeHomeCurrent + 1 }}/{{
                this.imgUrls ? this.imgUrls.length : ""
              }}
            </div>
          </van-swipe>
        </div>
        <p class="fgx" v-if="protectionScheme != ''"></p>
        <!-- 一树一策 -->
        <div class="treesTrategy ggList" v-if="protectionScheme != ''">
          <div class="ggPd">
            <p class="ggTit">
              <a
                href="javascript:void(0)"
                :class="[isRepaired == true ? '' : 'bottomChangeColor']"
                >一树一策</a
              >
            </p>
            <p class="trategyMain" v-html="protectionScheme"></p>
          </div>
        </div>
        <p class="fgx" v-if="this.influenceFactor != ''"></p>
        <div class="treesTrategy ggList" v-if="this.influenceFactor != ''">
          <div class="ggPd">
            <p class="ggTit">
              <a
                href="javascript:void(0)"
                :class="[isRepaired == true ? '' : 'bottomChangeColor']"
                >影响生长环境因素</a
              >
            </p>
            <p class="trategyMain" v-html="influenceFactor"></p>
          </div>
        </div>
        <p class="fgx" v-if="this.specialDescription != ''"></p>
        <div class="treesTrategy ggList" v-if="this.specialDescription != ''">
          <div class="ggPd">
            <p class="ggTit">
              <a
                href="javascript:void(0)"
                :class="[isRepaired == true ? '' : 'bottomChangeColor']"
                >树木特殊状况描述</a
              >
            </p>
            <p class="trategyMain" v-html="specialDescription"></p>
          </div>
        </div>
        <p class="fgx" v-if="this.identifyRecord != ''"></p>
        <div class="treesTrategy ggList" v-if="this.identifyRecord != ''">
          <div class="ggPd">
            <p class="ggTit">
              <a
                href="javascript:void(0)"
                :class="[isRepaired == true ? '' : 'bottomChangeColor']"
                >树种鉴定记载</a
              >
            </p>
            <p class="trategyMain" v-html="identifyRecord"></p>
          </div>
        </div>

        <p class="fgx" v-if="showRepairlData"></p>
        <div class="treeRepair ggList" v-if="showRepairlData">
          <div class="ggPd">
            <p class="ggTit">
              <a
                href="javascript:void(0)"
                :class="[isRepaired == true ? '' : 'bottomChangeColor']"
                >古树修复</a
              >
            </p>
          </div>
          <div class="repairlist clearfix">
            <span class="verticalLine"></span>
            <ul class="repairBox clearfix">
              <li
                class="clearfix"
                v-for="(item, index) in RepairlData"
                :key="index + 'ddfw'"
              >
                <div class="repairList">
                  <p>{{ item.repairTime.substr(0, 10) }}</p>
                  <p>{{ item.repairRemark }}</p>
                  <div
                    class="repairImgBox"
                    v-if="item.imgList && item.imgList[0]"
                    @click="showrepairImgList(item)"
                  >
                    <img :src="item.imgList[0]" />
                    <span class="repairImgIntro"
                      >共有{{ item.imgList.length }}张&emsp;点击查看</span
                    >
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <p class="fgx"></p>
        <div class="discussMain ggList" id="discussList">
          <div class="ggPd">
            <p class="ggTit">
              <a
                href="javascript:void(0)"
                :class="[isRepaired == true ? '' : 'bottomChangeColor']"
                >评论</a
              >
            </p>
          </div>
          <!-- 评论组件 -->
          <comment
            :reloadType="reloadType"
            :appType="treeType"
            @getType="changeReload"
            @seeImgList="changeSeeImgList"
          ></comment>
          <!-- 添加评论 -->
          <div class="addCommentBox">
            <img
              :src="baseUrl + 'addCommontIcon.png'"
              alt
              srcset
              @click="addForestCommont"
            />
          </div>
        </div>
      </div>

      <!-- 弹出层 -->

      <!-- 放大图片组件 -->
      <van-image-preview
        v-model="magnifyImgShow"
        :images="magnifyImgList"
        class="magnifyImg"
        :start-position="magnifyImgListIndex"
      />

      <!-- 地图导航 -->
      <van-popup
        v-model="showGetAmap"
        position="bottom"
        @close="showGetAmap = false"
        class="guardBox"
      >
        <div class="roleHeader clearfix">请选择导航</div>
        <p>
          <a href="javascript:void(0)" @click="getAmap(1)">高德地图</a>
        </p>
        <p>
          <a href="javascript:void(0)" @click="getAmap(2)">百度地图</a>
        </p>
      </van-popup>
      <!-- 增加评论弹出框 -->
      <van-popup
        v-model="addCommontPicker"
        position="bottom"
        round
        closeable
        @click-overlay="closeAddNote"
        @close="closeAddNote"
        close-icon="close"
        class="addJsPickerBox"
      >
        <p class="addTit">新增评论</p>
        <div class="addPage">
          <p class="fgx"></p>
          <van-cell-group class="baseNone beizhu">
            <van-field
              class="readonlyText"
              value="评价内容"
              required
              readonly
            />
            <van-field
              v-model="addcommontData.content"
              rows="3"
              autosize
              type="textarea"
              maxlength="500"
              placeholder="请输入评价内容"
            />
          </van-cell-group>
          <!-- 评价列表 -->
          <div class="evaluateBox" v-if="evaluateList[0]">
            <van-checkbox-group v-model="selectEvaluate" ref="checkboxGroup">
              <van-row gutter="20" class="itemBox">
                <van-col
                  v-for="item in evaluateList"
                  :key="item.id"
                  @click="addGoodNumber(item)"
                  :class="['itemList', item.isChecked ? 'selectItem' : '']"
                >
                  <van-checkbox :name="item.code">{{
                    item.dictName
                  }}</van-checkbox>
                </van-col>
              </van-row>
            </van-checkbox-group>
          </div>
          <p class="fgx"></p>
          <div class="uploadBox">
            <van-field value="现场图片" readonly />
            <div class="clearfix">
              <ul class="fl clearfix">
                <li
                  v-for="(item, index) in addcommontData.imgList"
                  :key="index"
                  class="fl"
                >
                  <div class="upload">
                    <van-image
                      width="100%"
                      height="100%"
                      fit="cover"
                      :src="item"
                      @click="seeCommentImg(addcommontData.imgList, index)"
                    />
                    <van-icon
                      name="close"
                      @click="delImg(index)"
                      class="delImgBtn"
                    />
                  </div>
                </li>
              </ul>
              <ul
                class="fl"
                v-if="
                  addcommontData.imgList && addcommontData.imgList.length < 9
                "
              >
                <li @click="addgetImgs">
                  <div class="upload">
                    <i
                      class="
                        van-icon van-icon-photograph
                        van-uploader__upload-icon
                      "
                    ></i>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="btnBox">
            <van-button
              type="primary"
              :loading="btnLoading"
              loading-text="保存中..."
              @click="saveComment"
              class="btn"
              >提交</van-button
            >
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import oldOne from "@/assets/images/oldOne.png";
import oldOneFalse from "@/assets/images/oldOneFalse.png";
import oldTwo from "@/assets/images/oldTwo.png";
import oldTwoFalse from "@/assets/images/oldTwoFalse.png";
import oldThree from "@/assets/images/oldThree.png";
import oldThreeFalse from "@/assets/images/oldThreeFalse.png";
import oldFour from "@/assets/images/oldFour.png";
import oldFourFalse from "@/assets/images/oldFourFalse.png";
import famousTrees from "@/assets/images/famousTrees.png";
import gradeOne from "@/assets/images/gradeOne.png";
import gradeTwo from "@/assets/images/gradeTwo.png";
import gradeThree from "@/assets/images/gradeThree.png";
import logoOne from "@/assets/images/logoOne.png";
import logoTwo from "@/assets/images/logoTwo.png";
import cameraBig from "@/assets/images/cameraBig.png";
import group from "@/assets/images/group.png";
import shareImg from "@/assets/images/share.png";
const comment = () => import("@/components/treeModule/comment");
const monitoringSwipe = () => import("@/components/treeModule/monitoringSwipe");

export default {
  name: "gushuDetail",
  data() {
    return {
      treeType: "", //区别古树, 用于掉接口用
      //以下为引用图片
      isMultiple: false,
      oldTreeGrade: oldOne,
      logoTwo: logoTwo,
      logoOne: logoOne,
      oldOne: oldOne, //一级
      oldOneFalse: oldOneFalse,
      oldTwo: oldTwo, //二级
      oldTwoFalse: oldTwoFalse,
      oldThree: oldThree, //三级
      oldThreeFalse: oldThreeFalse,
      oldFour: oldFour, //名品
      oldFourFalse: oldFourFalse,
      famousTrees: famousTrees, //名木
      cameraBig: cameraBig,
      gradeTwo: gradeTwo,
      gradeOne: gradeOne,
      gradeThree: gradeThree,
      group: group,
      shareImg: shareImg,
      shareImgs: "", //分享的图片
      //古树档案信息

      loadingPicker: true, //一进页面加载动画
      baseUrl: process.env.BASE_URL,
      treeCode: "",
      userId: "", //用户Id
      sysToken: "",
      sysClient: "",
      baseTreeMsg: {}, //古树内容对象
      treeId: "", //古树Id
      crown: "", //树木冠幅
      catalog: "", //树木种类
      treeClassesName: "", //树木等级
      entryName: "", //树木种类
      family: "", //树木科
      genus: "", //树木属
      historicCulture: "", //历史文化
      isRepaired: false, //是否修复
      latinName: "", //树木拉丁文
      treeLat: "", //树木位置纬度
      treelon: "", //树木位置经度
      management: "", //树木管理单位
      placeName: "", //小地名
      protectionScheme: "", //一树一策
      influenceFactor: "", //影响生长环境因素
      specialDescription: "", //树木特殊状况描述
      identifyRecord: "", //树种鉴定记载
      elevation: "", //海拔
      exposure: "", //坡向
      slope: "", //坡度
      position: "", //坡位
      growthPlace: "", //生长场所
      growthCharacteristic: "", //特点
      ownership: "", //权属
      soilName: "", //土壤名称
      growthPotential: "", //生长势
      growingEnvironment: "", //生长环境
      extantState: "", //现存状态
      characteristicCode: "", //特征代码
      protection: "", //地上保护现状
      rejuvenation: "", //养护复壮现状
      regionCode: "", //所在区域
      regionCodeName: "", //树木位置
      rodDiameter: "", //胸围（杆径）
      shortUrl: "", //短地址
      treeAge: "", //树龄
      treeClasses: "", //树木级别
      treeHeight: "", //树木高度
      scanNum: "", //扫描次数
      treeIcon: "", //数目等级图片
      //古树之家--相册
      imgUrls: "", //古树相册
      monitors: [], //监控

      //古树修复记录
      RepairlData: {}, //修复记录
      showRepairlData: false,
      //评论
      showDiscuss: false, //默认不显示评论框
      evaluateList: [], //评价列表
      commentData: [],
      commentCount: 0,
      page: 0,
      pageSize: 10,
      showHeaderFalse: false, //
      TreeHomeCurrent: 0, //古树之家轮播list
      magnifyImgShow: false, //默认不显示
      magnifyImgList: [], //放大图片list
      magnifyImgListIndex: 0, //放大图片下标
      showShare: false, //古树分享
      showSocket: true, //古树监控

      showGetAmap: false, //地图导航
      //添加评论

      addCommontPicker: false, //新增评论弹框
      btnLoading: false,
      selectEvaluate: [], //选中的评价
      addcommontData: {
        content: "", //评论内容
        evaluateDic: [], //评价数组
        imgList: [], //评论图片
        treeId: "", //古树ID
      },
      userLat: "", //用户纬度
      userLon: "", //用户经度
      reloadType: "", //刷新列表
      clientType: getDeviceType(), //手机类型
    };
  },
  components: {
    comment,
    monitoringSwipe,
  },
  created() {
    this.treeId = this.$route.query.treeId || "";
    this.sysToken = this.$route.query.sysToken || "";
    this.sysClient = this.$route.query.sysClient || "";
  },
  mounted() {
    this.treeType = this.sysClient == "baike" ? "oldTree" : "";
    //app图片回调
    window.setImgUrl = this.setImgUrl;
    //获取经纬度
    window.setPoints = this.setPoints;
    this.initPage();
    // this.getPoints();
  },
  methods: {
    initPage() {
      //初始化页面
      let _this = this;
      _this.$api.slbkOldTree
        .getTreeDetail(_this.treeId)
        .then((res) => {
          if (res.code == "1") {
            _this.$set(_this.addcommontData, "treeId", _this.treeId);
            _this.loadingPicker = false;
            _this.scanNum = res.data.scanNum;
            _this.treeCode = res.data.treeCode;
            _this.crown = res.data.crown;
            _this.entryName = res.data.entryName;
            _this.treeClassesName = res.data.treeClassesName;
            _this.historicCulture = res.data.historicCulture;
            _this.latinName = res.data.latinName;
            _this.management = res.data.management;
            _this.treeLat = parseFloat(res.data.lat);
            _this.treeLon = parseFloat(res.data.lon);
            _this.placeName = res.data.placeName;
            _this.growthPlace = res.data.growthPlace; //生长场所
            _this.growthCharacteristic = res.data.growthCharacteristic; //特点
            _this.ownership = res.data.ownership; //权属
            _this.soilName = res.data.soilName; //土壤名称
            _this.growthPotential = res.data.growthPotential; //生长势
            _this.growingEnvironment = res.data.growingEnvironment; //生长环境
            _this.extantState = res.data.extantState; //现存状态
            _this.characteristicCode = res.data.characteristicCode; //特征代码
            // _this.protection = res.data.protection; //地上保护现状
            // _this.rejuvenation = res.data.rejuvenation; //养护复壮现状
            if (res.data.protection == "") {
              _this.protection = null; //地上保护现状
            } else {
              _this.protection = res.data.protection; //地上保护现状
            }
            if (res.data.rejuvenation == "") {
              _this.rejuvenation = null; //养护复壮现状
            } else {
              _this.rejuvenation = res.data.rejuvenation; //养护复壮现状
            }
            if (
              res.data.influenceFactor == null ||
              res.data.influenceFactor == "" ||
              res.data.influenceFactor == "null"
            ) {
              _this.influenceFactor = "";
            } else {
              _this.influenceFactor = res.data.influenceFactor; //影响生长环境因素
            }
            if (
              res.data.specialDescription == null ||
              res.data.specialDescription == "" ||
              res.data.specialDescription == "null"
            ) {
              _this.specialDescription = "";
            } else {
              _this.specialDescription = res.data.specialDescription; //树木特殊状况描述
            }
            if (
              res.data.identifyRecord == null ||
              res.data.identifyRecord == "" ||
              res.data.identifyRecord == "null"
            ) {
              _this.identifyRecord = "";
            } else {
              _this.identifyRecord = res.data.identifyRecord; //树种鉴定记载
            }

            _this.elevation = res.data.elevation; //海拔
            _this.exposure = res.data.exposure; //坡向
            _this.slope = res.data.slope; //坡度
            _this.position = res.data.position; //坡位
            if (
              res.data.protectionScheme == null ||
              res.data.protectionScheme == "null" ||
              res.data.protectionScheme == ""
            ) {
              _this.protectionScheme = "";
            } else {
              _this.protectionScheme = res.data.protectionScheme;
            }
            _this.regionCodeName =
              res.data.shengName +
              "/" +
              res.data.shiName +
              "/" +
              res.data.xianName +
              "/" +
              res.data.xiangName +
              "/" +
              res.data.cunName;
            _this.rodDiameter = res.data.rodDiameter;
            _this.treeAge = res.data.treeAge;
            _this.treeHeight = res.data.treeHeight;
            _this.viewCount = res.data.viewCount;
            _this.treeClasses = res.data.treeClasses;
            _this.isRepaired = true;
            if (_this.isRepaired == false) {
              this.showHeaderFalse = true;
            }
            if (
              _this.treeClasses == "treeClasses004" &&
              _this.isRepaired == true
            ) {
              _this.oldTreeGrade = _this.oldFour;
              _this.shareImgs =
                "http://www.ahdhst.com/dhome-oldTree/shareImgs/oldFour.png";
            } else if (
              _this.treeClasses == "treeClasses004" &&
              _this.isRepaired == false
            ) {
              _this.oldTreeGrade = _this.oldFourFalse;
              _this.shareImgs =
                "http://www.ahdhst.com/dhome-oldTree/shareImgs/oldFour.png";
            } else if (
              _this.treeClasses == "treeClasses001" &&
              _this.isRepaired == true
            ) {
              _this.oldTreeGrade = _this.oldOne;
              _this.shareImgs =
                "http://www.ahdhst.com/dhome-oldTree/shareImgs/oldOne.png";
            } else if (
              _this.treeClasses == "treeClasses001" &&
              _this.isRepaired == false
            ) {
              _this.oldTreeGrade = _this.oldOneFalse;
              _this.shareImgs =
                "http://www.ahdhst.com/dhome-oldTree/shareImgs/oldOne.png";
            } else if (
              _this.treeClasses == "treeClasses002" &&
              _this.isRepaired == true
            ) {
              _this.oldTreeGrade = _this.oldTwo;
              _this.shareImgs =
                "http://www.ahdhst.com/dhome-oldTree/shareImgs/oldTwo.png";
            } else if (
              _this.treeClasses == "treeClasses002" &&
              _this.isRepaired == false
            ) {
              _this.oldTreeGrade = _this.oldTwoFalse;
              _this.shareImgs =
                "http://www.ahdhst.com/dhome-oldTree/shareImgs/oldTwo.png";
            } else if (
              _this.treeClasses == "treeClasses003" &&
              _this.isRepaired == true
            ) {
              _this.oldTreeGrade = _this.oldThree;
              _this.shareImgs =
                "http://www.ahdhst.com/dhome-oldTree/shareImgs/oldThree.png";
            } else if (
              _this.treeClasses == "treeClasses003" &&
              _this.isRepaired == false
            ) {
              _this.oldTreeGrade = _this.oldThreeFalse;
              _this.shareImgs =
                "http://www.ahdhst.com/dhome-oldTree/shareImgs/oldThree.png";
            }

            if (res.data.treeClassesName == null) {
              document.title = res.data.entryName + "-" + res.data.placeName; //设置title的值
            } else if (res.data.entryName == null) {
              document.title =
                res.data.treeClassesName + "-" + res.data.placeName; //设置title的值。
            } else if (res.data.placeName == null) {
              document.title =
                res.data.treeClassesName + "-" + res.data.entryName; //设置title的值。
            } else {
              document.title =
                res.data.treeClassesName +
                "-" +
                res.data.entryName +
                "-" +
                res.data.placeName; //设置title的值。
            }
            _this.monitors = res.data.monitors;
            _this.imgUrls = res.data.imgUrls;
            _this.initTreeRepaired(); //获取古树修复记录
            // _this.getEvaluateList(); //获取评价属性列表
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStr(item) {
      //截取子符串
      this.entryFamily = item[item.length - 2].split(/\(.*?\)/)[0];
      this.entryCategory = item[item.length - 1].split(/\(.*?\)/)[0];
    },
    initTreeRepaired() {
      let _this = this;
      _this.$api.slbkOldTree
        .getTreeRepairDetail(1, 100, _this.treeId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            if (res.data.total != "0") {
              _this.RepairlData = res.data.list;
              if (_this.RepairlData[0]) {
                this.showRepairlData = true;
              }
            } else {
              _this.archivesTreeHome = "";
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPoints() {
      //获取经纬度地址信息
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(207, "");
      } else {
        //IOS

        window.webkit.messageHandlers.getPoints.postMessage(null);
      }
    },
    setPoints(data) {
      let pointsData = "";
      if (this.clientType == "android") {
        pointsData = window.android.getInfo(208, "");
        pointsData = pointsData.split("|");
        this.userLon = parseFloat(pointsData[0]);
        this.userLat = parseFloat(pointsData[1]);
      } else {
        pointsData = JSON.parse(data);
        this.userLon = parseFloat(pointsData.curLongitude);
        this.userLat = parseFloat(pointsData.curLatitude);
      }
      this.initPage();
    },
    // initGuShuImg() {
    //   let _this = this;
    //   _this.$api.slbkOldTree
    //     .mapGuShuImg({ pageNum: 1, pageSize: 100, objid: _this.objid })
    //     .then(res => {
    //       if (res.code == "1" && res.data != null) {
    //         if (res.data.total != "0") {
    //           _this.archivesTreeHome = res.data.list;
    //         } else {
    //           _this.archivesTreeHome = "";
    //         }
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     });
    // },
    getAmap(type) {
      let addressData = this.regionCodeName.split("/");
      let len = addressData.length;
      //导航
      if (type == "1") {
        //高德
        window.location.href =
          "https://uri.amap.com/marker?position=" +
          this.treeLon +
          "," +
          this.treeLat +
          "&name=" +
          addressData[len - 3] +
          addressData[len - 2] +
          addressData[len - 1] +
          "&src=mypage&coordinate=wgs84&callnative=1";
      } else {
        //百度
        window.location.href =
          "http://api.map.baidu.com/marker?location= " +
          this.treeLat +
          "," +
          this.treeLon +
          "&title=" +
          addressData[len - 3] +
          addressData[len - 2] +
          addressData[len - 1] +
          this.placeName +
          "&content=" +
          this.placeName +
          " &output=html";
      }
    },
    imgError(item, type) {
      //图片地址失效
      if (type == "1") {
        item.url = this.group;
      } else {
        item.headImgUrl = this.group;
      }
    },
    onChange(index) {
      this.TreeHomeCurrent = index;
    },

    //放大图片
    magnifyImg(itemIndex) {
      this.magnifyImgListIndex = parseInt(itemIndex);
      this.magnifyImgList = this.imgUrls;
      this.magnifyImgShow = true;
    },

    showrepairImgList(item) {
      //点击查看古树修复图片
      this.magnifyImgList = item.imgList;
      this.magnifyImgShow = true;
    },

    addForestCommont() {
      //显示评论框
      this.addCommontPicker = true;
    },
    getEvaluateList() {
      let _this = this;
      let lonlat = "point(" + _this.userLon + " " + this.userLat + ")";
      _this.$api.slbkOldTree
        .treeEvaluateList({ id: _this.treeId, lonLat: lonlat }, "oldTree")
        .then((res) => {
          if (res.code == "1" && res.data != null && res.data[0]) {
            console.log(res.data);
            _this.evaluateList = res.data;
            for (let i = 0; i < _this.evaluateList.length; i++) {
              _this.evaluateList[i].isChecked = false;
            }
            console.log(_this.evaluateList, "_this.evaluateList");
          } else {
            _this.evaluateList = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addGoodNumber(item) {
      let _this = this;
      _this.$set(item, "isChecked", !item.isChecked);
    },
    changeSeeImgList(data) {
      let magnifyList = [];
      this.magnifyImgListIndex = parseInt(data.index);
      data.imgData.forEach(SelectBigImgs);
      function SelectBigImgs(item, index) {
        magnifyList.push(item);
      }
      this.magnifyImgList = magnifyList;
      this.magnifyImgShow = true;
    },
    // 查看图片
    seeCommentImg(commentFiles, index) {
      let magnifyList = [];
      this.magnifyImgListIndex = parseInt(index);
      commentFiles.forEach(SelectBigImgs);
      function SelectBigImgs(item, index) {
        magnifyList.push(item);
      }
      this.magnifyImgList = magnifyList;
      this.magnifyImgShow = true;
    },
    //添加图片
    addgetImgs() {
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(103, "2");
      } else {
        //IOS
        window.webkit.messageHandlers.getImgs.postMessage("2");
      }
    },
    //图片回调
    setImgUrl(iosImg) {
      let _this = this;
      let imgData = ""; //获取上传后的图片相关信息
      let newArrList = _this.addcommontData.imgList;
      if (this.clientType == "android") {
        imgData = JSON.parse(window.android.getInfo(104, ""));
      } else {
        imgData = JSON.parse(iosImg);
      }
      console.log(imgData, "imgData");
      if (newArrList && newArrList[0]) {
        newArrList.unshift(imgData.url);
      } else {
        newArrList = [];
        newArrList.push(imgData.url);
      }
      console.log(_this.addcommontData, "addcommontData");
      _this.$set(_this.addcommontData, "imgList", newArrList);
    },
    closeAddNote() {
      this.$set(this.addcommontData, "content", "");
      this.$set(this.addcommontData, "imgList", []);
      this.$set(this.addcommontData, "evaluateDic", []);
      this.addCommontPicker = false;
    },
    delImg(index) {
      if (this.addcommontData.files != []) {
        this.$dialog
          .confirm({
            title: "提示",
            message: "是否确认删除图片",
          })
          .then(() => {
            let imgsList = this.addcommontData.imgList; //.splice(index, 1)
            imgsList.splice(index, 1);

            this.$set(this.addcommontData, "imgList", []);
            if (imgsList.length > 0) {
              this.$set(this.addcommontData, "imgList", imgsList);
            } else {
              this.$set(this.addcommontData, "imgList", []);
            }
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    saveComment() {
      let _this = this;
      if (_this.addcommontData.content == "") {
        _this.$toast("评论内容不能为空！");
      } else {
        if (_this.evaluateList && _this.evaluateList[0]) {
          _this.evaluateList.forEach((item) => {
            if (item.isChecked) {
              _this.addcommontData.evaluateDic.push(item.code);
            }
          });
        }
        _this.btnLoading = true;
        _this.$api.slbkOldTree
          .addGuShuComment(_this.addcommontData, "oldTree")
          .then((res) => {
            if (res.code == "1") {
              this.addCommontPicker = false;
              _this.$toast("发布成功！");
              _this.$set(_this.addcommontData, "content", "");
              _this.$set(_this.addcommontData, "evaluateDic", []);
              _this.$set(_this.addcommontData, "imgList", []);
              _this.reloadType = "2";
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
    changeReload() {
      this.reloadType = "";
    },
    // propsHide(status) {
    //   this.showDiscuss = false;
    // },

    //路由跳转
    getMap() {
      //返回地图
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(115, "3");
      } else {
        //IOS
        window.webkit.messageHandlers.closePage.postMessage("3");
      }
    },

    //分享
    Share() {
      let _this = this;
      let getUrl =
        "http://www.ahdhst.com/dhome-lzz-lzt-h5/gushuDetail?id=" +
        _this.treeId +
        "&sysToken=" +
        _this.sysToken +
        "&sysClient=" +
        _this.sysClient;

      let tit = "古树名木保护与修复";
      let intro = "";
      if (_this.treeClassesName == null) {
        intro = _this.entryName; //这里请特别注意是要去除html
      } else if (_this.entryName == null) {
        intro = _this.treeClassesName; //这里请特别注意是要去除html
      } else {
        intro = _this.treeClassesName + "-" + _this.entryName; //这里请特别注意是要去除html
      }
      let data = {
        url: getUrl,
        title: tit,
        img: _this.shareImgs,
        intro: intro,
      };
      if (this.clientType == "android") {
        //安卓
        console.log(data);
        window.android.getInfo(205, JSON.stringify(data));
      } else {
        //IOS
        window.webkit.messageHandlers.getShare.postMessage(
          JSON.stringify(data)
        );
      }
    },
  },
};
</script>
<style lang="less">
@import "././css/gushuDetail.less";
</style>